import MDinput from '@/components/MDinput';
import { validatorRequire } from '@/utils/validators';

export function getFormDefinition(vue) {
  return {
    description: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 16,
        required: true
      },
      rules: [
        {
          validator: validatorRequire
        }
      ]
    }
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
